import React from 'react';
import {checkNullStr, getCurrUrlParamValue} from "../../common/fusion-ui/utils/ReactUtils";
import {Label} from "../../common/fusion-ui";
import {useAuth} from "../context/AuthProvider";
import {useTheme} from "../../common/ProjectThemeProvider";
import {Keys} from "../config/AppConfig";
import {IconClass} from "../../common/fusion-ui/config/FusionConfig";

const InvalidBypassTokenLabel = React.memo(({mtn = 2}) => {
    const TAG = "InvalidBypassTokenLabel";
    const theme = useTheme();
    const {bypassTokenChecking, bypassTokenVerified, bypassTokenCheckMsg} = useAuth();

    return (<>
            {(checkNullStr(getCurrUrlParamValue(Keys.urlParam_loginBypassTokenAlias)) &&
                    !bypassTokenChecking && !bypassTokenVerified && checkNullStr(bypassTokenCheckMsg)) &&
                <div className={`d-flex w-100 jc-center mt-n${mtn} mb-2`}>
                    <Label className={'fw-semi-bold px-3 py-1 w-100 fs-normal'}
                           width={'100%'}
                           bgColor={'var(--danger)'} color={theme.textWhite}
                           iconClass={`${IconClass.iButton} me-1`}>
                        {bypassTokenCheckMsg}
                    </Label>
                </div>}
        </>
    )
});
export default InvalidBypassTokenLabel;
